/**
 * Temporary closure flags.
 *
 * TO REOPEN: set the relevant value to `false`.
 * Everything closure-related on the site reads from this one object.
 */
export const CLOSURES = {
  fishing: false,
  rvSites: false,
  generalCamping: false,
  wildHorse: false,
} as const;

export const CLOSURE_HEADING = "TEMPORARILY CLOSED – WILDFIRE";

export const CLOSURE_MESSAGE_RV =
  "RV sites and General Camping at Mountain View and Sheep Creek are temporarily closed due to nearby wildfire activity. Please do not enter or make reservations for these areas until further notice. Wild Horse Reservoir remains open.";

export const CLOSURE_MESSAGE_GENERAL =
  "Fishing permits are temporarily unavailable due to nearby wildfire activity. Access to the reservoirs is closed for public safety. Please do not enter or make reservations until further notice.";

/** True when any area is currently closed. */
export const anyClosure =
  CLOSURES.fishing || CLOSURES.rvSites || CLOSURES.generalCamping || CLOSURES.wildHorse;
